import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, FormControl, FormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { HttpClient } from '@angular/common/http';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
  selector: 'app-user-leaves',
  templateUrl: './user-leaves.component.html',
  styleUrl: './user-leaves.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CKEditorModule, LoaderComponent, RouterModule
  ],
  providers: [DatePipe],
})
export class UserLeavesComponent implements OnInit {

  text = '';
  public showSpinner = false;
  public user: any = [];
  public isHidden = false;
  public dateShow = true;
  public absent: any = '';
  public isEdit = false;
  public stats: any = [];
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate = new Date();
  public paidLeaves: any = 0;
  public rejectedLeaves: any = 0;
  public renewalYear = new Date().getFullYear();
  lastWorkingDay: any;
  hidenData: any = {};
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  source: any;
  total_leave: any;
  leavenames: any;
  leave_types: any;
  selectedLeave = '';
  selectedPaymentStatus = 'paid';
  selectedLeaveName: any;
  checkLeave: any;
  start_date_form: any;
  end_date_form: any;
  applyButton = false;
  leave_type: any;
  leave_type_id: any;
  selectedStaffImage: string | null = null;
  selectedStaffName: string | null = null;
  otherusers: any;
  selectedUserName = ''; // Holds the selected user's name
  selectedUserImage = '';
  selectedLeaveType = 'self';
  searchQuery: any;
  selectedUserId: any;
  leave_category: any;
  filteredUsers: any;
  userroleParse: any;
  user_role: any;
  remainleaves: any;
  joiningDate: any;
  appliedleaveData: any;
  formdata: any;
  otherUserid: any;
  isDateInput = false;  // Flag to track the input type
  isTouched = false;
  isEndDateInput = false;
  isEndDateTouched = false;




  formData: FormData = new FormData();



  inputType = 'text';
  inputType1 = 'text';
  public Editor = ClassicEditor;
  selectedFileName: any;
  profileImageInvalid = false;
  selectedImage: string | ArrayBuffer | null = null;
  imagePath: any;
  leave_doc: any;
  leave_name: any;
  user_absent: any[] = [];
  selectedPDF: any;
  theme_id: any;
  select_Date: any;

  get_date_for_short_leave: any;
  shortleave_data_startTime: any;
  shortleave_data_endTime: any;
  shortleave_data_time: any;
  team_lead_action: any;
  leave_check: any;
  custome_message: any;
  shortleave_start_time: any;
  shortleave_end_time: any;


  constructor(
    private _leaveService: LeaveService,
    private route: ActivatedRoute,
    private mediaService: MediaService,
    public location: Location,
    private http: HttpClient,
    public router: Router,
    @Inject(AddService) private addService: AddService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private settings: SettingservicesService,
    private attendaceService: AttendanceService,

  ) {
    this.user_detail();
    const date = new Date();
    this.isEdit = this.route.snapshot.queryParams.isEdit ?? false;
    if (this.isEdit) {
      this.hidenData = JSON.parse(this.route.snapshot.queryParams.data);
    }

    const lastFifthDayDate = date.getDate() - 4 > 0 ? date.getDate() - 9 : 25;
    const month = date.getDate() - 4 > 0 ? date.getMonth() : date.getMonth() - 1;
    const startdate = this.datepipe.transform(new Date(date.getFullYear(), month, lastFifthDayDate), 'yyyy/MM/dd');
    const endDate = this.datepipe.transform(new Date(date.getFullYear(), month + 1, 0), 'yyyy/MM/dd');
    this.attendaceService.getAttendance(startdate, endDate, null, null).then(response => {
      if (response.data.attendance.length > 0) {
        const index = response.data.attendance.slice().reverse().findIndex((x: any) => x.check_in != "" && x.check_out != "");
        if (index >= 0) {
          const finalIndex = index >= 0 ? (response.data.attendance.length - 1) - index : index;
          this.lastWorkingDay = new Date(response.data.attendance[finalIndex].date);
        }
        else {
          this.lastWorkingDay = new Date(date.getFullYear(), month, 1);
        }
      }
    });
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
    this.user_detail();
  }

  ngOnInit(): void {

    this.absents();
    this.paidLeaves = this.route.snapshot.paramMap.get('paidLeaves');
    this.rejectedLeaves = this.route.snapshot.paramMap.get('rejectedLeaves');
    this.paidLeaves = +this.paidLeaves;
    this.rejectedLeaves = +this.rejectedLeaves;

    if (this.hidenData?.description) {
      this.text = this.hidenData?.description;  // Pre-fill the text with the description
    }
    this.selectedImage = this.hidenData?.leave_doc;
    this.leave_name = this.hidenData?.source;
    this.selectedPaymentStatus = this.hidenData?.leave_payment_status;
    this.leave_type = this.hidenData?.leave_type_id;
    if (this.leave_type == 3) {
      this.isHidden = true;
      this.dateShow = false;
    } else {
      this.isHidden = false;
      this.dateShow = true;
    }


    this.shortleave_data_startTime = this.hidenData?.shortLeave_start_time;
    this.shortleave_data_endTime = this.hidenData?.shortLeave_end_time;
    this.shortleave_data_time = this.hidenData?.shortLeave_hours
    this.get_date_for_short_leave = this.hidenData?.end_date;





    this.getTextForAutomation();
    // this.getOtherUser();
  }
  file: File | null = null;

  onFileChange(event: any) {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileToUpload = selectedFile as File;
      this.formData.append('file', fileToUpload, fileToUpload.name);
      this.uploadProfileImage();

      const fileSizeKB = selectedFile.size / 1024;
      const fileType = selectedFile.type;

      if (fileSizeKB <= 1025) {
        this.selectedFileName = selectedFile.name;
        this.profileImageInvalid = false;

        const reader = new FileReader();
        reader.onload = (e: any) => {
          if (fileType.startsWith('image/')) {
            this.selectedImage = e.target.result; // Set the selected image data
            this.selectedPDF = null; // Clear PDF data if any
          }
          // else if (fileType === 'application/pdf') {
          //   this.selectedPDF = e.target.result;
          //   this.selectedImage = null; // Clear image data if any
          // }
        };
        reader.readAsDataURL(selectedFile);
      } else {
        this.selectedFileName = null;
        this.selectedImage = null;
        this.selectedPDF = null;
        this.profileImageInvalid = true;
        event.target.value = ''; // Clear the input value
      }
    }
  }


  changeEndDate(formValue: any) {

    this.showSpinner = true;
    const leave_type_id = formValue.leave_type_id
    const short_start_date = formValue.date_for_short_leave ?? 'Null';
    const start_time = formValue.shortleave_start_time ?? 'Null';
    const end_time = formValue.shortleave_end_time ?? 'Null';
    const start_date = formValue.start_date ?? 'Null';
    const formatted_start_date = this.convertDate(start_date) ?? 'Null';
    const end_date = formValue.end_date ?? 'Null';
    this._leaveService.getcheckapplyLeave(leave_type_id, short_start_date, start_time, end_time, formatted_start_date, end_date).then((value: any) => {
      if (value.success == true) {
        // means found data agaisnt this data warning check show true

        if (value.message.type == "Atendance") {
          this.custome_message = "Your Attendance Record is Found in this day.Do you Still Want To Proceed."
        } else (
          this.custome_message = "Your Leave Record is Found in this day.Do you Still Want To Proceed."
        )

        Swal.fire({
          iconHtml: '<img src="../../../../assets/theme1/warning.png" alt="image">',
          title: this.custome_message,
          showConfirmButton: true,
          confirmButtonText: "Yes",
          showDenyButton: true,
          denyButtonText: "No",
          allowOutsideClick: false, // prevent closing on outside click
          allowEscapeKey: false     // prevent closing on ESC
        }).then((result) => {
          if (result.isConfirmed) {
            // ✅ user clicked Yes → keep selected start_date and set end_date to it
            this.end_date_form = formValue.end_date;
          } else if (result.isDenied) {
            this.start_date_form = null;
            this.end_date_form = null;
            this.get_date_for_short_leave = null;
            this.shortleave_data_startTime = null;
            this.shortleave_data_endTime = null;
            this.shortleave_data_time = null;
          }
        });

      }

      this.showSpinner = false;

    });

  }


  convertDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  toApiFormat(date: string | null): string | null {
    if (!date) return null;

    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return null;

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  uploadProfileImage() {
    this.showSpinner = true;
    this.mediaService.uploadImage(this.formData).subscribe(
      (response) => {
        this.showSpinner = false;
        let l: any;
        l = response;
        this.imagePath = l.data.path;
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }


  onFocus(field: string) {
    if (field === 'start') {
      this.inputType = 'date';
    } else if (field === 'end') {
      this.inputType1 = 'date';
    }
  }

  // Handle blur event to switch input type back to 'text' and format the date
  onBlur(field: string) {
    if (field === 'start') {
      this.inputType = 'text';
      // Format the date to 'Jan 01, 2025' when the user blurs the input
      this.start_date_form = this.formatDate(this.start_date_form);
      this.isTouched = true;
    } else if (field === 'end') {
      this.inputType1 = 'text';
      // Format the date to 'Jan 01, 2025' when the user blurs the input
      this.end_date_form = this.formatDate(this.end_date_form);
      this.isEndDateTouched = true;
    }
  }

  // Helper function to format the date to 'Jan 01, 2025'
  formatDate(date: string | null): string | null {
    if (!date) return null;

    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) return null;  // If invalid date, return null

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = dateObj.toLocaleString('default', { month: 'short' });  // e.g., 'Jan'
    const year = dateObj.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  // Optional: You can clear the error message when the user starts typing

  onStartDateChange() {
    if (this.start_date_form) {
      this.isTouched = false;
    }
  }

  onEndDateChange() {
    if (this.end_date_form) {
      this.isEndDateTouched = false;
    }
  }

  trimText() {
    this.text = this.text.replace(/\s+/g, ' ').trim();
  }

  getLeaveStats() {
    this._leaveService.getStatsFilter().then((value: any) => {

      this.absent = value.data.absents;
      this.stats = value.data.leaves;

    });
  }

  absents() {
    this.showSpinner = true;

    this._leaveService.getAbsents().then((value: any) => {
      this.user_absent = value.data;
      this.showSpinner = false;

    });
  }

  selectDate(date: Date) {
    const formattedDate = this.formatDatenew(date);
    this.start_date_form = formattedDate;
    this.end_date_form = formattedDate;
    this.select_Date = formattedDate;
  }

  formatDatenew(date: Date | string): string {
    const validDate = new Date(date);
    if (isNaN(validDate.getTime())) {
      return '';
    }

    const day = String(validDate.getDate()).padStart(2, '0');
    const month = validDate.toLocaleString('default', { month: 'short' });  // e.g. 'Jan'
    const year = validDate.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    
    if (f.value.leave_action == null || f.value.leave_name == null || f.value.leave_payment_status == undefined || f.value.leave_type_id == null || f.value.title == null) {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: "Fields is Required",
        showConfirmButton: false,
        timer: 1500,
      });
    }


  this.getAllLeaveData(f);
  
    this.showSpinner = false;

    // this.leavecheck(f);
  }

  formSubmit(f: NgForm) {
    let _start_date = f.value.start_date;
    let _end_date = f.value.end_date;
    const _shortleave_end_time = f.value.shortleave_end_time ?? null;
    const _shortleave_start_time = f.value.shortleave_start_time ?? null;

    if (f.value.leave_type_id == '3') {
      _start_date = f.value.date_for_short_leave;
      _end_date = f.value.date_for_short_leave;
    }
    const leaveAction = f.value.leave_action;
    const s_date = _start_date;
    const e_Date = _end_date;
    const start_date = new Date(s_date);
    const end_Date = new Date(e_Date);
    // Check if startDate is valid
    let formattedStartDate: string | null = null;
    if (!isNaN(start_date.getTime())) {
      // If valid, format as yyyy-mm-dd
      const startYear = start_date.getFullYear();
      const startMonth = String(start_date.getMonth() + 1).padStart(2, '0');
      const startDay = String(start_date.getDate()).padStart(2, '0');
      formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
    } else {
      // If invalid, set formattedStartDate to null
      formattedStartDate = null;
    }

    // Handle end_date
    const endDate = new Date(end_Date);

    // Check if the end_date is valid
    let formattedEndDate: string | null = null; // Default to null if invalid
    if (!isNaN(endDate.getTime())) {
      const endYear = endDate.getFullYear();
      const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
      const endDay = String(endDate.getDate()).padStart(2, '0');
      formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
    } else {
      // If endDate is invalid, set formattedEndDate to null
      formattedEndDate = null;
    }

    // this.getAllLeaveData(this.formdata);
    _start_date = formattedStartDate;
    _end_date = formattedEndDate;
    this.showSpinner = true;
    this.source = 'web_app';

    if (this.lastWorkingDay === undefined || this.lastWorkingDay === null) {
      this.showSpinner = true;

      this.lastWorkingDay = new Date();
    }
    let month = this.lastWorkingDay.getMonth();
    let day = this.lastWorkingDay.getDate() - 5;
    if (day < 0) {
      month = month - 1;
      day = 30 - (5 - this.lastWorkingDay.getDate());
    }
    const lastWorkingDate = new Date(this.lastWorkingDay.getFullYear(), month, day);
    const leaveStartDate = new Date(_start_date);
    const leaveEndDate = new Date(_end_date);
    
    if (leaveEndDate.getTime() <= lastWorkingDate.getTime()) {
      this.showSpinner = false;
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/warning_icon.svg"  alt="image" >',
        title: "Date should be greater than your last working day's date.",
        showConfirmButton: false,
        timer: 2000,
      });
    }
    else {
      if (_end_date == null) {
        this.showSpinner = true;
        _end_date = _start_date
      }
      else if (leaveEndDate.getTime() < leaveStartDate.getTime()) {
        this.showSpinner = false;
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/warning_icon.svg"  alt="image" >',
          title: "End Date should be greater than or equal to Start Date.",
          showConfirmButton: false,
          timer: 2000,
        });
          return;
      }

      if (this.isEdit) {
        // need to do new api call to update the leave
        this.showSpinner = true;
        // if (f.value.leave_type_id == '3') {
        //   f.value.start_time = f.value.date_for_short_leave;
        //   f.value.end_time = f.value.date_for_short_leave;
        // }
        this._leaveService
          .updateLeave(
            this.hidenData.id,
           f.value.title,
            f.value.leave_type_id,
            _start_date,
            _end_date,
            f.value.leave_payment_status,
            f.value.description,
            f.value.short_leave,
            f.value.leave_name,
            this.source,
            f.value.leave_action,
            f.value.leave_attachment,
            _shortleave_end_time,
            _shortleave_start_time,
            this.shortleave_data_time,
            this.team_lead_action,

          )
          .then((value) => {
            this.showSpinner = false;
            if (value.success == true) {
              Swal.fire({
                iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
                title: 'Application Updated Successfully',
                showConfirmButton: false,
                timer: 1500,
              });
              if (this.theme_id == 1 || this.theme_id == 2) {
                this.router.navigate(['user-leaves-view']);

              } else {
                this.router.navigate(['leaves']);
              }
            } else {
              Swal.fire({
                iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
                title: value.message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
      } else {
        const performApply = () => {
          this.showSpinner = true;
          this._leaveService
            .getApplyResult(
              f.value.title,
              f.value.leave_type_id,
              _start_date,
              _end_date,
              f.value.leave_payment_status,
              f.value.description,
              f.value.short_leave,
              f.value.leave_name,
              this.source,
              this.selectedUserId,
              f.value.leave_action,
              f.value.leave_attachment,
              _shortleave_end_time,
              _shortleave_start_time,
              this.shortleave_data_time,
              this.team_lead_action,
            )
            .then((value) => {
              this.showSpinner = false;
              if (value.success == true) {
                Swal.fire({
                  iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
                  title: 'Application Submitted Successfully',
                  showConfirmButton: false,
                  timer: 1500,
                });
                
                if (this.theme_id == 1 || this.theme_id == 2) {
                  this.router.navigate(['user-leaves-view']);
                } else {
                  this.router.navigate(['leaves']);
                }
              } else {
                Swal.fire({
                  iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
                  title: value.message,
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            });
        };

        this.showSpinner = true;
        this._leaveService.checkLeaveLimit(this.selectedUserId, _start_date).then((limitRes: any) => {
          this.showSpinner = false;
          if (limitRes.success && limitRes.data?.is_over_limit) {
            Swal.fire({
              icon: 'warning',
              title: 'Monthly Limit Reached',
              text: 'You have already used your 2 requests this month. This request may not be approved. Do you want to proceed?',
              showCancelButton: true,
              confirmButtonText: 'Understood',
              cancelButtonText: 'Cancel'
            }).then((result) => {
              if (result.isConfirmed) {
                performApply();
              }
            });
          } else {
            performApply();
          }
        });
      }
    }
  }

  onCancel(form: NgForm) {
    form.reset();
  }

  checkType(deviceValue: any, value: any) {
    this.leave_type = value
    if (value == 3) {
      this.isHidden = true;
      this.dateShow = false;
    } else {
      this.isHidden = false;
      this.dateShow = true;
    }
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.total_leave = this.userInfo?.total_leaves
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.userroleParse = JSON.parse(this.userInfo.user_role.user_roles);
      this.user_role = this.userroleParse?.role_type
      this.joiningDate = this.userInfo?.joining_date
      const specifiedDate = new Date('2024-09-01');
      const userJoiningDate = new Date(this.joiningDate);
      this.theme_id = this.userInfo.theme_id
    })
    this.leavestype();
    this.showSpinner = false;
  }

  leavestype() {
    this.showSpinner = true;
    this.dashboardService.getleaves().then((value) => {
      this.leavenames = value.data
      this.leave_category = this.leavenames.length;
      if (this.hidenData?.leave_name) {
        this.onLeaveNameChange({ target: { value: this.hidenData.leave_name } });
      }
      if (this.hidenData && this.hidenData.start_date) {
        const startDateString = this.hidenData.start_date;
        const startDate = new Date(startDateString);
        if (!isNaN(startDate.getTime())) {
          const formattedDate = this.formatDateEdit(startDate);
          this.start_date_form = formattedDate;
        } else {
          console.error("Invalid Date");
        }
      }

      if (this.hidenData && this.hidenData.end_date) {
        this.end_date_form = this.hidenData.end_date;

        const endDateString = this.hidenData.end_date;
        const endDate = new Date(endDateString);
        if (!isNaN(endDate.getTime())) {
          const formattedendDate = this.formatDateEdit(endDate);
          this.end_date_form = formattedendDate;
        } else {
          console.error("Invalid Date");
        }
      }
      this.showSpinner = false;
    })
  }

  formatDateEdit(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits for day
    const month = date.toLocaleString('default', { month: 'short' });  // Get abbreviated month name
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
  }



  showDatePicker() {
    this.isDateInput = true;  // Change type to date
  }

  // Check if the field is empty after blur and revert to text if needed
  checkIfEmpty() {
    if (!this.start_date_form) {
      this.isDateInput = false;  // Revert to text if no date is selected
    }
    this.isTouched = true;  // Mark the field as touched
  }
  onLeaveNameChange(event: any) {
    this.selectedLeaveName = event.target ? event.target.value : this.hidenData?.leave_name; // Use hidden value if in edit mode

    const filteredLeaves = this.leavenames.filter((leave: any) => leave.leave_name === this.selectedLeaveName);
    this.team_lead_action = filteredLeaves[0].team_lead_action_type;
    // Reset leave_types
    this.leave_types = [];

    // Concatenate all the leave types from the filtered leaves
    filteredLeaves.forEach((leave: any) => {
      this.leave_types = this.leave_types.concat(leave.types);
    });

    // Pre-select leave type based on hidden data (for editing case)
    if (this.hidenData?.leave_name === this.selectedLeaveName) {
      const defaultLeaveType = this.hidenData?.leave_payment_status; // Assuming this holds the payment status (paid/unpaid)
      this.selectedPaymentStatus = defaultLeaveType; // Pre-select the leave type
    }
  }

  showEndDatePicker() {
    this.isEndDateInput = true;
  }

  // Revert input type to 'text' if no value is selected for the End Date field
  checkIfEndDateEmpty() {
    if (!this.end_date_form) {
      this.isEndDateInput = false; // Change back to text if date is empty
    }
    this.isEndDateTouched = true; // Mark input as touched
  }
  // onPaymentStatusChange(event: any) {
  //   const selectedPaymentStatus = event.target.value;
  //   this.leavecheck(selectedPaymentStatus);
  // }

  // onDateChange() {
  //   this.leavecheck(this.selectedLeaveName);
  // }

  selectStaff(name: string, image: string) {
    this.selectedStaffName = name;
    this.selectedStaffImage = image;
  }

  clearInput() {
    this.selectedStaffName = null;
    this.selectedStaffImage = null;
  }


  getOtherUser() {
    this.showSpinner = true;
    this.dashboardService.getusers().then((value) => {
      this.otherusers = value.data
      this.filterUsers()
    })

  }


  // Filter users based on input
  filterUsers() {
    if (this.selectedUserName) {
      this.filteredUsers = this.otherusers.filter((user: any) =>
        (user.first_name + ' ' + user.last_name).toLowerCase().includes(this.selectedUserName.toLowerCase())
      );
    } else {
      this.filteredUsers = this.otherusers;
    }
    this.showSpinner = false;

  }

  // Call selectUser when user clicks a result
  // selectUser(user: any) {
  //   this.selectedUserName = user.first_name + ' ' + user.last_name;
  //   this.selectedUserImage = user.profile_image;
  //   this.filteredUsers = []; // Hide the results after selection
  // }







  selectUser(user: any): void {
    this.selectedUserName = `${user.first_name} ${user.last_name}`;
    this.selectedUserImage = user.profile_image ? user.profile_image : 'assets/images/question.jpg';
    this.selectedUserId = user?.id
    // this.leavecheck(this.selectedUserId);
    this.showSpinner = false;
  }

  onLeaveTypeChange(event: any): void {
    this.selectedLeaveType = event.target.value;
    if (this.selectedLeaveType === 'other') {
      this.getOtherUser(); // Call the function when 'Others' is selected
    }
    // this.leavecheck(this.selectedLeaveType);
  }

  backward() {
    this.router.navigate(['user-leaves-view']);
  }



  leavecheck(f: any) {
    this.selectedUserId
    this.selectedLeaveType
    this.selectedPaymentStatus
    this.selectedLeaveName
    this.start_date_form
    this.end_date_form
    this.leave_type
    this.dashboardService.leaveCount(this.selectedPaymentStatus, this.selectedLeaveName, this.start_date_form, this.end_date_form, this.selectedLeaveType, this.selectedUserId).then((value) => {
      this.checkLeave = value;
      if (this.checkLeave?.success == true) {
        this.applyButton = true
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      else {
        this.applyButton = false
        this.formSubmit(f)
      }
      this.showSpinner = false;
    })

  }


  remainingLeaves() {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      this.remainleaves = value.data.data
    })
    this.showSpinner = false;
  }

  //    getAllLeaveData() {
  //     this.leaveService.getAllLeave().then((value) => {
  //      const leaveData = value.data
  //       this.showSpinner = false;
  //     });
  //   }

  getAllLeaveData(f: NgForm) {
    
    if (this.isEdit) {
      this.hidenData = JSON.parse(this.route.snapshot.queryParams.data);
    }
    let s_date = f.value.start_date;
    let e_Date = f.value.end_date;
    if (f.value.leave_type_id == '3') {
      s_date = f.value.date_for_short_leave;
      e_Date = f.value.date_for_short_leave;
    }
    const start_date = new Date(s_date);
    const end_Date = new Date(e_Date);
    // Check if startDate is valid
    let formattedStartDate: string | null = null;
    if (!isNaN(start_date.getTime())) {
      // If valid, format as yyyy-mm-dd
      const startYear = start_date.getFullYear();
      const startMonth = String(start_date.getMonth() + 1).padStart(2, '0');
      const startDay = String(start_date.getDate()).padStart(2, '0');
      formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
    } else {
      // If invalid, set formattedStartDate to null
      formattedStartDate = null;
    }

    // Handle end_date
    const endDate = new Date(end_Date);

    // Check if the end_date is valid
    let formattedEndDate: string | null = null; // Default to null if invalid
    if (!isNaN(endDate.getTime())) {
      const endYear = endDate.getFullYear();
      const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
      const endDay = String(endDate.getDate()).padStart(2, '0');
      formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
    } else {
      // If endDate is invalid, set formattedEndDate to null
      formattedEndDate = null;
    }

    if (this.selectedLeaveType === 'other') {
      this.otherUserid = this.selectedUserId;
    }
    this._leaveService.getAllUserLeave(this.otherUserid).then((value: any) => {
      const leaveData = value.data;
      this.showSpinner = false;
      this.getRemainingLeaves(leaveData, formattedStartDate, formattedEndDate, f.value.leave_name, f.value.leave_payment_status, f);
    });
  }

  getRemainingLeaves(leaveData: any, startDate: any, endDate: any, leaveName: any, leavePaymentStatus: any, f: NgForm) {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      const remainingLeaves = value.data.data;
      let days = 0;
      remainingLeaves.forEach((remainingLeave: any) => {
        if (remainingLeave.leave_name === leaveName && remainingLeave.leave_type === leavePaymentStatus) {
          const filteredLeaves = leaveData.filter(
            (leave: any) =>
              leave.leave_name === remainingLeave.leave_name &&
              (leave.status === 'pending' || leave.status === 'approved') &&
              (!this.isEdit || leave.id !== this.hidenData.id)
          );
          filteredLeaves.forEach((leave: any) => {
            if (leave.leave_type_id === 2) {
              const leavesDays = this.calculateDateDifference(leave.start_date, leave.end_date);
              days = days + leavesDays; // Full day
            } else if (leave.leave_type_id === 3) {
              if (leave.shortLeave_hours) {
                const shotLeaveDays = Math.round((leave.shortLeave_hours / 8) * 100) / 100;
                // hALF day
                days += shotLeaveDays;
              }
              else { // if shortLeave_hours==null then add 0.5 hours for old half leaves
                days += 0.5;
              }
            }
          });
          const appliedLeaves = days;
          const remainingLeaveCount = remainingLeave.assigned_leaves - appliedLeaves;
          if (f.value.leave_type_id == '2') {
            var dateDifference = this.calculateDateDifference(startDate, endDate);
          } else {
            var dateDifference = this.shortleave_data_time / 8;
          }
          if (appliedLeaves >= remainingLeave.assigned_leaves) { //leave_count
            this.applyButton = true;
            Swal.fire({
              iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
              title: `You Already Applied ${appliedLeaves} days of ${remainingLeave.leave_name}.`,
              showConfirmButton: false,
              timer: 3000,
            });
            return

          }

          if (dateDifference > remainingLeaveCount) {
            this.applyButton = true;
            Swal.fire({
              iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
              title: `You can't apply for ${dateDifference} days of ${remainingLeave.leave_name}, only ${remainingLeaveCount} days are remaining.`,
              showConfirmButton: false,
              timer: 3000,
            });
            return

          }
          this.formSubmit(f)
        }

      });
    });
    this.showSpinner = false;
  }
  calculateDateDifference(startDate: string, endDate: string) {
    const start = new Date(startDate);
    start.setDate(start.getDate() - 1);
    const end = new Date(endDate);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  // checkAppliedLeaves(leaveData: any, remainingLeaves: any, dateDifference: any, leaveName: any, leavePaymentStatus: any, f: NgForm) {
  //   remainingLeaves.forEach((remainingLeave: any) => {
  //     if (remainingLeave.leave_name === leaveName && remainingLeave.leave_type === leavePaymentStatus) {
  //       const appliedLeaves = leaveData.filter(
  //         (leave: any) =>
  //           leave.leave_name === remainingLeave.leave_name &&
  //           (leave.status === 'pending' || leave.status === 'approved')
  //       ).length;

  //       const remainingLeaveCount = remainingLeave.assigned_leaves - remainingLeave.leave_count;

  //       if (appliedLeaves >= remainingLeave.assigned_leaves) { //leave_count
  //         this.applyButton = true;
  //         Swal.fire({
  //           iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
  //           title: `You Already Applied ${appliedLeaves} days of ${remainingLeave.leave_name}.`,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         });
  //         return

  //       }

  //       if (dateDifference > remainingLeaveCount) {
  //         this.applyButton = true;
  //         Swal.fire({
  //           iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
  //           title: `You can't apply for ${dateDifference} days of ${remainingLeave.leave_name}, only ${remainingLeaveCount} days are remaining.`,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         });
  //         return

  //       }
  //       this.formSubmit(f)
  //     }
  //   });
  // }

  leaveInfo() {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      this.remainleaves = value.data.data
    })
    this.showSpinner = false;
  }


  // calculation of working hours
  calculateWorkingHours() {
    if (this.shortleave_data_startTime && this.shortleave_data_endTime) {
      const startTime = new Date(`1970-01-01T${this.shortleave_data_startTime}`);
      const endTime = new Date(`1970-01-01T${this.shortleave_data_endTime}`);

      // If end time is before start time, assume it's the next day
      if (endTime <= startTime) {
        endTime.setDate(endTime.getDate() + 1);
      }

      const diff = (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60); // Difference in hours
      this.shortleave_data_time = diff.toFixed(2); // Set total working hours with 2 decimal places
    } else {
      this.shortleave_data_time = null; // Clear total working hours if times are not set
    }
  }

  leaveautotemplateData: any[] = [];
  gettextauto: any;
  getTextForAutomation() {
    this.showSpinner = true;
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data;
      this.leaveautotemplateData = this.gettextauto.filter(
        (item: any) => item.title.trim() === "userside_apply_leave"
      );
      this.showSpinner = false;
    })
  }
  setReason(text: string) {
    this.text = text;
  }
  //   public suggestedTemplates: { keyword: string; content: string }[] = [];

  //   public templates: { [key: string]: string } = {
  //     sick: `Dear [Manager's Name],<br><br>
  // I am writing to inform you that I am feeling unwell and will not be able to attend work today. I kindly request [number] days of sick leave to rest and recover.<br><br>`,

  //     urgent: `Dear [Manager's Name],<br><br>
  // I would like to request urgent leave starting from [insert date] due to an unexpected personal matter. I apologize for the short notice and appreciate your understanding.<br>`,

  //     personal: `Dear [Manager's Name],<br><br>
  // I am writing to request leave for personal reasons from [start date] to [end date]. I will ensure a proper handover of responsibilities.<br><br>Thank you`
  //   };

  //   onEditorChange(event: any): void {
  //     const content = event.editor.getData().toLowerCase();
  //     this.suggestedTemplates = [];

  //     for (const keyword in this.templates) {
  //       // Word boundary match (e.g. only match full word 's', not in 'personal')
  //       const regex = new RegExp(`\\b${keyword}\\b`, 'i');
  //       if (regex.test(content)) {
  //         this.suggestedTemplates.push({ keyword, content: this.templates[keyword] });
  //       }
  //     }
  //   }

  //   applyTemplate(templateContent: string): void {
  //     this.text = templateContent;
  //     this.suggestedTemplates = [];
  //   }

}
